import React from 'react';
import {NativeStackScreenProps} from '@react-navigation/native-stack';

import {StackParamList} from '../../../../../../navigators';
import {SuccessTemplate} from '../../../../../../components/templates/success';
import {
  PrimaryButton,
  SecondaryButton,
} from '../../../../../../components/buttons';
import {message} from '../../../../../../utils/messages';

type ScreenProps = NativeStackScreenProps<StackParamList, 'InvoiceSuccessFull'>;

const InvoiceSuccessFull = ({navigation}: ScreenProps) => {
  const handlePrimaryPress = () => {
    navigation.navigate('SalesmanClientDashboard');
  };
  const handleSecondaryPress = () => {
    navigation.navigate('InvoiceCandidateList');
  };

  return (
    <SuccessTemplate
      title={message('salesman-invoice-success-title')}
      summary={message('salesman-invoice-success-summary')}>
      <PrimaryButton
        label={message('salesman-invoice-success-primary-button')}
        onPress={() => handlePrimaryPress()}
      />
      <SecondaryButton
        label={message('salesman-invoice-success-secondary-button')}
        mt="5"
        onPress={() => handleSecondaryPress()}
      />
    </SuccessTemplate>
  );
};

export default InvoiceSuccessFull;
